import { useMemo } from 'react';

interface UseNumberParameterOptions {
  searchParams: URLSearchParams;
  key: string;
  fallback: number;
  minimum?: number;
}

const useNumberParameter = ({ searchParams, key, fallback, minimum = 1 }: UseNumberParameterOptions): number => {
  return useMemo(() => {
    const value = searchParams.get(key);
    if (!value) return fallback;
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return fallback;
    if (parsed < minimum) return fallback;
    return parsed;
  }, [searchParams, key, fallback, minimum]);
};

export default useNumberParameter;
